export const QA_NAME_USER_PROFILE_PAGE = 'UserProfile'

export const USER_PROFILE_PAGE_EMAIL_DRAFT_PREFIX = 'user-profile-email'
